<button
  class="sidebar-toggle"
  (click)="toggle.emit()"
  [attr.aria-expanded]="isExpanded">
  <app-icon
    [name]="isExpanded ? 'chevron-left' : 'chevron-right'"
    [size]="IconSize.Medium">
  </app-icon>
</button>
  
